<template>
  <div class="menu-prd  pb-3">
    <div class="row">
      <div class="item-menu col-md-3 col-6">
          <div class='item-menu-prd mn-1'>              
                <router-link exact  :to="{  name: 'productByCategory',  params: { slug: 'bulong' }}">Bulong</router-link>
          </div>
      </div>
      <div class="item-menu col-md-3 col-6">
          <div class='item-menu-prd mn-2'>
              <router-link exact  :to="{  name: 'productByCategory',  params: { slug: 'tyren' }}">Tyren</router-link>
          </div>
      </div>
      <div class="item-menu col-md-3 col-6">
          <div class='item-menu-prd mn-3'>
              <router-link exact  :to="{  name: 'productByCategory',  params: { slug: 'tan' }}">Tán</router-link>
          </div>
      </div>
      <div class="item-menu col-md-3 col-6">
          <div class='item-menu-prd mn-4'>
              <router-link exact  :to="{  name: 'productByCategory',  params: { slug: 'tac-ke' }}">Tắc kê</router-link>
          </div>
      </div>
      <div class="item-menu col-md-3  col-6">
          <div class='item-menu-prd mn-5'>
              <router-link exact  :to="{  name: 'productByCategory',  params: { slug: 'cum-treo' }}">Cùm treo</router-link>
          </div>
      </div>
      <div class="item-menu col-md-3  col-6">
          <div class='item-menu-prd mn-6'>
              <router-link exact  :to="{  name: 'productByCategory',  params: { slug: 'cum-ubolt' }}">Cùm Ubolt</router-link>
          </div>
      </div>
      <div class="item-menu col-md-3  col-6">
          <div class='item-menu-prd mn-7'>
              <router-link exact  :to="{  name: 'productByCategory',  params: { slug: 'cum-xa-go' }}">Cùm xà gồ</router-link>
          </div>
      </div>
      <div class="item-menu col-md-3  col-6">
          <div class='item-menu-prd mn-8'>
              <router-link exact  :to="{  name: 'productByCategory',  params: { slug: 'oc-vit-cac-loai' }}">Ốc vít các loại</router-link>
          </div>
      </div>
      <div class="item-menu col-md-3  col-6">
          <div class='item-menu-prd mn-9'>
              <router-link exact  :to="{  name: 'productByCategory',  params: { slug: 'sat-hinh-u-v-i' }}">Sắt hình: U - V - I</router-link>
            </div>
      </div>
      <div class="item-menu col-md-3  col-6">
          <div class='item-menu-prd mn-10'>
              <router-link exact  :to="{  name: 'productByCategory',  params: { slug: 'day-cap-day-xich' }}">Dây cáp - Dây xích</router-link>              
          </div>
      </div>
      <div class="item-menu col-md-3  col-6">
          <div class='item-menu-prd mn-11'>
              <router-link exact  :to="{  name: 'productByCategory',  params: { slug: 'mani-oc-xiet-cap-tang-do' }}">Maní - Ốc xiết cáp - Tăng đơ</router-link>              
          </div>
      </div>
      <div class="item-menu col-md-3 col-6">
          <div class='item-menu-prd mn-12'>
              <router-link exact  :to="{  name: 'productByCategory',  params: { slug: 'thanh-chong-da-nang' }}">Thanh chống đa năng</router-link>              
          </div>
      </div>
      <div class="item-menu col-md-3  col-6">
          <div class='item-menu-prd mn-13'>
              <router-link exact  :to="{  name: 'productByCategory',  params: { slug: 'dinh' }}">Đinh</router-link>              
          </div>
      </div>
      <div class="item-menu col-md-3  col-6">
          <div class='item-menu-prd mn-14'>
              <router-link exact  :to="{  name: 'productByCategory',  params: { slug: 'son-chong-ri' }}">Sơn chống rỉ</router-link>              
          </div>
      </div>
      <div class="item-menu col-md-3 col-6">
          <div class='item-menu-prd mn-15'>
              <router-link exact  :to="{  name: 'productByCategory',  params: { slug: 'gia-cong-co-khi' }}">Gia công cơ khí</router-link>
          </div>
      </div>
      <div class="item-menu col-md-3 col-6">
          <div class='item-menu-prd mn-16'>
              <router-link exact  :to="{  name: 'productByCategory',  params: { slug: 'san-pham-khac' }}">Sản phẩm khác</router-link>              
          </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "RwvMenuPrd",
  props: {
    categories: Array
  }
};
</script>